export const globalStoreName = "SIMPLE_MOVIE_APP_GLOBAL_STORE";
export const popularMoviesStoreName = "POPULAR_MOVIES_STORE";
export const nowPlayingMoviesStoreName = "NOW_PLAYING_MOVIES_STORE";
export const upcomingMoviesStoreName = "UPCOMING_MOVIES_STORE";
export const discoverStoreName = "DISCOVER_STORE";
export const topRatedMoviesStoreName = "TOP_RATED_MOVIES_STORE";
export const authStoreName = "AUTH_STORE";
export const userSettingsStoreName = "USER_SETTINGS";
export const storeVersion = 1;
